function PredictionLoading() {
  return (
    <div className="rounded-3xl border border-slate-800 bg-slate-900/80 p-8 text-center text-slate-300 shadow-xl shadow-sky-950/20">
      Loading predictions...
    </div>
  )
}

export default PredictionLoading;